import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton } from "@mui/material";

type SmallDevicesMenuIconProps = {
  onClick: () => void;
};
const SmallDevicesMenuIcon = ({ onClick }: SmallDevicesMenuIconProps) => {
  return (
    <Box sx={{ display: { xs: "flex", lg: "none", marginLeft: "auto" } }}>
      <IconButton size="large" aria-controls="menu-appbar" aria-haspopup="true" onClick={onClick}>
        <MenuIcon />
      </IconButton>
    </Box>
  );
};

export default SmallDevicesMenuIcon;
